.card {
  background: #fff;
  border-radius: 2px;
  overflow: hidden;
  box-shadow: var(--shadow-card);
  display: grid;
}

.image {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.content {
  padding: var(--space-2);
  display: grid;
  gap: var(--space-1);
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

.content h3 {
  margin: 0;
  font-size: 0.7rem;
}

.cardLink {
  display: block;
  color: inherit;
  text-decoration: none;
  transition: transform 160ms ease, box-shadow 160ms ease;
}

.cardLink:hover .card,
.cardLink:focus-visible .card {
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.26);
}

.cardLink:hover .image,
.cardLink:focus-visible .image {
  transform: scale(1.02);
}

.cardLink .image { transition: transform 220ms ease; }
